import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFleet = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M1 8a3 3 0 0 1 3-3h12c1.515 0 2.851 1.043 3.315 2.382l.043.13.005.018.975 3.484a2 2 0 0 1 1.188.582l.898.91A2 2 0 0 1 23 13.91V17a2 2 0 0 1-2 2h-2.171a3 3 0 0 1-5.658 0H9.83a3 3 0 0 1-5.658 0H3a2 2 0 0 1-2-2zm6 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2m9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m2.258-6-.818-2.919C17.258 7.486 16.634 7 16 7h-2v4zM3 17h1.171a3 3 0 0 1 5.658 0h3.342a3 3 0 0 1 5.658 0H21v-3.09l-.898-.91H14a2 2 0 0 1-2-2V7H4a1 1 0 0 0-1 1z"
	})
});
export default SvgFleet;
